import { render, staticRenderFns } from "./PointRecordDialog.vue?vue&type=template&id=855d460c&scoped=true&"
import script from "./PointRecordDialog.vue?vue&type=script&lang=js&"
export * from "./PointRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855d460c",
  null
  
)

export default component.exports